import React, { useContext, useState } from "react";

// mui
import Grid from "@mui/material/Grid";

// component
import { useIntl } from "react-intl";
import axios from "axios";
import PropTypes from "prop-types";
import ButtonMain from "../../../../../../../../common/components/button/ButtonMain";

// utils
import { downloadBlob, isEmpty } from "../../../../../../../../common/utils";
import { StoreContext } from "../../../../../../../../store/StoreProvider";
import Act from "../../../../../../../../store/actions";
import { OCR, OCR_CONTENT, OCR_GRPAH } from "../../../Config";
import ocrFailedImg from "../../../../../../../../../images/ocr_image/ocr_upload_error.svg";
import MsgDialog from "../../../../../../../../common/components/dialog/MsgDialog";
import ApiUrls from "../../../../../../../../api/project/ApiUrls";

const BottomTool = () => {
  const [state, dispatch] = useContext(StoreContext);
  const { digitalAI, sna } = state;
  const { ocrOriginalData, ocrImgList, finishOCR, ocrErrorCount, pagination } =
    digitalAI;
  const [open, setOpen] = useState(false);

  const intl = useIntl();

  const getAIContent = (ocrData) => {
    if (isEmpty(ocrData)) return null;
    return ocrData
      .filter((el) => OCR_CONTENT in el)
      .map((el) => el[OCR_CONTENT])
      .join("\n");
  };

  const updateOcrData = async (item) => {
    if (isEmpty(ocrOriginalData)) return;
    const cloneOriginalData = ocrOriginalData.find(
      (i) => i.hasOcr === item.hasOcr
    );

    if (item.ocrContent === cloneOriginalData.ocrContent) return;

    const entry = {
      entrySrc: {
        graph: OCR_GRPAH(item.userId, item.fileName),
        classType: OCR,
        value: { ocrContent: cloneOriginalData.ocrContent },
        srcId: item.hasOcr,
      },
      entryDst: {
        graph: OCR_GRPAH(item.userId, item.fileName),
        classType: OCR,
        value: { ocrContent: item.ocrContent },
        srcId: item.hasOcr,
      },
    };

    await axios.put(ApiUrls.updateOcrData, entry);
    // ocrImgList.find((i) => i.hasOcr === item.hasOcr)[OCR_CONTENT] =
    //   cloneUpdateData.ocrContent;
  };

  const getTxt = (ocrData) => {
    if (isEmpty(ocrData)) return null;
    return ocrData
      .filter((el) => OCR_CONTENT in el)
      .map((el) => `${el.imgUrl}\n${el[OCR_CONTENT]}`)
      .join("\n\n");
  };

  const handleDownload = async () => {
    if (isEmpty(ocrImgList)) return;
    const ocrData = getTxt(ocrImgList);

    await Promise.all(
      ocrImgList.map(async (item) => {
        updateOcrData(item);
      })
    ).then(() => {
      const txtToBlob = new Blob([ocrData], {
        type: "text/plain;charset=utf8",
      });
      const fileName = `ocr-result-${new Date().getTime()}.txt`;

      downloadBlob(txtToBlob, fileName);
    });
  };

  const getAiQuota = async () => {
    const apiStr = process.env.REACT_APP_AI_QUOTA_API;
    const data = await axios.post(apiStr);
    const curUsage = data?.data;
    const quotaPercentage = Math.floor((1 - curUsage) * 100);
    const isQuotaExceeded = quotaPercentage <= 0;

    dispatch({
      type: Act.SNA_SET_QUOTA,
      payload: isQuotaExceeded ? 0 : quotaPercentage,
    });
  };

  const exportToAI = () => {
    if (isEmpty(ocrImgList)) return;

    // 辨識失敗的圖片，必須先刪除圖片才能跳轉至AIpage
    if (ocrErrorCount) {
      setOpen(true);
      return;
    }

    // 跳轉帶到AIpage的資料和下載的txt檔格式不同
    const ocrData = getAIContent(ocrImgList);
    const textData = getTxt(ocrImgList);

    const txtToBlob = new Blob([textData], { type: "text/plain;charset=utf8" });
    const fileName = `ocr-result-${new Date().getTime()}.txt`;

    getAiQuota().then(async () => {
      await Promise.all(
        ocrImgList.map(async (item) => {
          updateOcrData(item);
        })
      ).then(() => {
        downloadBlob(txtToBlob, fileName);
      });
    });

    dispatch({
      type: Act.SNA_SET_AI_INPUT_TXT,
      payload: ocrData || "",
    });

    // 跳轉畫面，並清空AI的內容
    dispatch({
      type: Act.SNA_SET_SUBPAGE,
      payload: "ai",
    });

    localStorage.setItem("AIFetch", false);

    dispatch({
      type: Act.SNA_SET_AI_FETCH_DATA,
      payload: "",
    });

    dispatch({
      type: Act.SNA_SET_AI_CURRENT_PAGE,
      payload: "main",
    });
  };

  return (
    <Grid item xs container columnGap={1}>
      <Grid item xs>
        <ButtonMain
          buttonProps={{
            sx: { borderRadius: "6px" },
            onClick: handleDownload,
            text: intl.formatMessage({
              id: "sna.sidetool.digitalAITool.ocr.download.txt",
              defaultMessage: "下載全部 TXT",
            }),
            disabled: isEmpty(ocrImgList) || !finishOCR,
            fullWidth: true,
            variant:
              isEmpty(ocrImgList) || !finishOCR
                ? "disableLinearGradient"
                : "linearGradient",
          }}
        />
      </Grid>
      <Grid item xs>
        <ButtonMain
          buttonProps={{
            sx: { borderRadius: "6px" },
            onClick: exportToAI,
            text: intl.formatMessage({
              id: "sna.sidetool.digitalAITool.ocr.exportToAI",
              defaultMessage: "下載並前往 AI 語意分析",
            }),
            disabled: isEmpty(ocrImgList) || !finishOCR,
            fullWidth: true,
            variant:
              isEmpty(ocrImgList) || !finishOCR
                ? "disableLinearGradient"
                : "linearGradient",
          }}
        />
        <MsgDialog
          setOpen={setOpen}
          open={open}
          src={ocrFailedImg}
          alt="ocrFailedImg"
          dialogTitleText={intl.formatMessage({
            id: "sna.sidetool.digitalAITool.ocr.delete.error",
            defaultMessage: "請先刪除無法辨識的檔案",
          })}
        />
      </Grid>
    </Grid>
  );
};

// BottomTool.propTypes = {
//   cloneOcrImageList: PropTypes.array.isRequired,
// };

export default BottomTool;
